import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { NotificationSharedItemAction } from './NotificationSharedItemAction';
export const ContactRequestReceivedActions = memo(({ notification }) => (_jsx(NotificationSharedItemAction, { notification: notification, targetPath: '/sharing/to-you' })));
